export default "__VITE_ASSET__BaZX2E$t__"